import React from 'react';
import ReportBox from "./ReportBox";

const ReportInventory = () => {
    return (
        <div>
            <ReportBox pageName="inventory" apiAddress="Pallet/InventoryReport" title="گزارش موجودی"/>

        </div>
    );
};

export default ReportInventory;